import { defineComponent as _defineComponent } from 'vue'
import {reactive, toRefs, watch} from "vue";
  import ModalDialog from "@/components/ModalDialog.vue";
  import EmployeeService, {EmploymentPeriodV3Dto} from "@/service/EmployeeService";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeDetailsCardEmploymentsHistory',
  props: {
    employeeUuid: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: () => false
    }
  },
  setup(__props) {

const props = __props

  

  const initialState = {
    dialog: false,
    employments: new Array<EmploymentPeriodV3Dto>()
  };

  const state = reactive({...initialState});

  // Loads the employments on every opening, so the history also shows employments changed since the last one
  const load = () => {
    if (props.employeeUuid) {
      EmployeeService.getEmployeeEmploymentsV3(props.employeeUuid)
        .then(employments => {
          state.employments = employments;
        });
    }
  };

  watch(() => state.dialog, open => {
    if (open) {
      load();
    }
  });

  const {dialog, employments} = toRefs(state);

return { __sfc: true,props, initialState, state, load, dialog, employments, ModalDialog }
}

})